// 子任务确定课题路由

export default [
  // 年度主题阐释
  {
    path: 'SubjectInterpretation',
    name: 'SubjectInterpretation',
    component: () =>
    import(/* webpackChunkName: "DetermineSubject" */ '@/components/sub-task/determine-subject/subject-interpretation')
  },
  {
    path: 'formTeam',
    name: 'formTeam',
    component: () =>
    import(/* webpackChunkName: "DetermineSubject" */ '@/components/sub-task/determine-subject/FormTeam')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/sub-task/determine-subject.js